import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from 'react-bootstrap';
import * as FaIcons from 'react-icons/fa';

const GeneratePdfModal = ({ 
  show, 
  onHide, 
  onConfirm, 
  loading, 
  cierreData,
  isGenerating = false
}) => {
  const handleConfirm = async () => {
    await onConfirm();
    // No cerrar el modal automáticamente, dejar que el padre lo controle
  };

  return (
    <Modal show={show} onHide={onHide} backdrop="static" keyboard={false}>
      <Modal.Header closeButton={!isGenerating}>
        <Modal.Title>
          <FaIcons.FaFilePdf className="me-2 text-danger" />
          {isGenerating ? 'Generando PDF...' : 'Generar PDF'}
        </Modal.Title>
      </Modal.Header>
      
      <Modal.Body>
        {isGenerating ? (
          // Estado de generación en progreso
          <div className="d-flex align-items-center gap-3">
            <div className="flex-shrink-0">
              <div 
                className="spinner-border text-primary" 
                style={{ width: '40px', height: '40px' }}
                role="status"
              >
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
            <div className="flex-grow-1">
              <h6 className="mb-2">Generando PDF...</h6>
              <p className="text-muted mb-2">
                El proceso de generación está en curso. Por favor espere...
              </p>
              {cierreData && (
                <div className="bg-light p-3 rounded">
                  <p className="mb-1">
                    <strong>Cierre:</strong> {cierreData.cierre}
                  </p>
                  <p className="mb-0">
                    <strong>Rango:</strong> {cierreData.fecha_inicio} - {cierreData.fecha_termino}
                  </p>
                </div>
              )}
              <div className="mt-3">
                <p className="text-info mb-0">
                  <FaIcons.FaClock className="me-1" />
                  Este proceso puede tardar varios minutos...
                </p>
              </div>
            </div>
          </div>
        ) : (
          // Estado inicial de confirmación
          <div className="d-flex align-items-start gap-3">
            <div className="flex-shrink-0">
              <FaIcons.FaQuestionCircle size={32} className="text-warning" />
            </div>
            <div className="flex-grow-1">
              <h6 className="mb-2">¿Está seguro que desea generar el PDF?</h6>
              {cierreData && (
                <div className="bg-light p-3 rounded">
                  <p className="mb-1">
                    <strong>Cierre:</strong> {cierreData.cierre}
                  </p>
                  <p className="mb-1">
                    <strong>Rango:</strong> {cierreData.fecha_inicio} - {cierreData.fecha_termino}
                  </p>
                  <p className="mb-0">
                    <strong>Estado:</strong> 
                    <span className={`ms-1 badge bg-${cierreData.estado_actual?.estado === 'Creado' ? 'success' : 'secondary'}`}>
                      {cierreData.estado_actual?.estado || 'Sin estado'}
                    </span>
                  </p>
                </div>
              )}
              <div className="mt-3">
                <p className="text-muted mb-0">
                  <FaIcons.FaInfoCircle className="me-1" />
                  Este proceso puede tardar varios minutos dependiendo de la cantidad de rutas.
                </p>
              </div>
            </div>
          </div>
        )}
      </Modal.Body>
      
      <Modal.Footer>
        {isGenerating ? (
          // Solo mostrar botón de cerrar cuando está generando
          <Button 
            variant="secondary" 
            onClick={onHide}
            disabled
          >
            <FaIcons.FaClock className="me-1" />
            Procesando...
          </Button>
        ) : (
          // Botones normales de confirmación
          <>
            <Button 
              variant="secondary" 
              onClick={onHide}
              disabled={loading}
            >
              Cancelar
            </Button>
            <Button 
              variant="danger" 
              onClick={handleConfirm}
              disabled={loading}
            >
              {loading ? (
                <>
                  <div 
                    className="spinner-border spinner-border-sm me-2" 
                    role="status"
                  >
                    <span className="visually-hidden">Loading...</span>
                  </div>
                  Generando...
                </>
              ) : (
                <>
                  <FaIcons.FaFilePdf className="me-1" />
                  Generar PDF
                </>
              )}
            </Button>
          </>
        )}
      </Modal.Footer>
    </Modal>
  );
};

GeneratePdfModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  isGenerating: PropTypes.bool,
  cierreData: PropTypes.shape({
    id: PropTypes.string,
    cierre: PropTypes.string,
    fecha_inicio: PropTypes.string,
    fecha_termino: PropTypes.string,
    estado_actual: PropTypes.shape({
      estado: PropTypes.string
    })
  })
};

GeneratePdfModal.defaultProps = {
  loading: false,
  isGenerating: false,
  cierreData: null
};

export default GeneratePdfModal;
